<template>
  <div id="container" class="mainBox trade-page">
    <nyTit pathUrl="/xiaofeiProductPriceData" />
    <Tit title="全县电商交易的总览数据" />

    <div class="content">
      <div class="left flex_column">
        <div class="left_top flex_column">
        <TradePanel title="全县电商交易总览" class="overview-panel">
          <div class="overview-grid">
            <MetricRing
              v-for="item in overviewData"
              :key="item.title"
              :title="item.title"
              :value="item.value"
              :unit="item.unit"
              :trend-value="item.trendValue"
              :trend-direction="item.trendDirection"
            />
          </div>
        </TradePanel>
        </div>

        <div class="left_down flex_wrap">
          <div class="left_down_left flex_wrap_pf flex_column">
          <TradePanel title="月度交易额与订单趋势">
            <div class="unit-label">单位：千万元 / 万单</div>
            <ChartBox :option="tradeTrendOption" />
          </TradePanel>
          </div>

          <div class="left_down_right flex_wrap_pf flex_column">
          <TradePanel title="电商特色农产品展示">
            <div class="product-grid">
              <div v-for="item in productData" :key="item" class="product-card">
                <!-- <text>{{ item.name }}</text> -->
                <img :src="item.img" alt="" />
              </div>
            </div>
          </TradePanel>
          </div>
        </div>
      </div>

      <div class="middle flex_wrap">
        <div class="middle_left flex_wrap_pf flex_column">
        <TradePanel title="用户行为转化分析" class="conversion-panel">
          <div class="conversion-list">
            <div v-for="item in conversionData" :key="item.label" class="conversion-row">
              <img :src="panelIcon" />
              <span>{{ item.label }}</span>
              <span class="conversion-value">{{ item.value }}</span>
            </div>
          </div>
        </TradePanel>

        <TradePanel title="全县特色农产品电商专题" class="sales-panel">
          <div class="sub-title">2026年7月特色农产品线上月销额</div>
          <ChartBox :option="onlineSalesOption" />
        </TradePanel>
        </div>

        <div class="middle_right flex_wrap_pf flex_column">
        <TradePanel title="用户地域来源渠道" class="source-panel height_500" >
          <ChartBox :option="sourceBarOption" />
        </TradePanel>

        <div class="donut-title" style="text-align: left;">农产品添加工线上销售占比</div>
        <div class="donut-row">
          <ChartBox :option="processingDonutOption" />
          <SalesRankList :data="processingRank" />
        </div>
        <div class="mini-gauge-row"><ProductMiniCards :data="miniGaugeData" /></div>
        </div>
      </div>

      <div class="right flex_wrap">
        <div class="right_l flex_wrap_pf flex_column">
          <div class="right_l_top flex_column">
            <TradePanel title="细分趋势与实时动态" class="compare-panel">
              <div class="unit-label percent">单位：%</div>
              <ChartBox :option="trendCompareOption" />
            </TradePanel>
          </div>

          <div class="right_l_down flex_column">
        <TradePanel title="全域交易TOP10" class="top-table-panel">
          <table class="top-table">
            <thead>
              <tr>
                <th>排名</th>
                <th>乡镇</th>
                <th>交易金额</th>
                <th>订单量</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in topList" :key="item.rank" :class="{ active: index === 1 }">
                <td>{{ item.rank }}</td>
                <td>{{ item.town }}</td>
                <td>{{ item.amount }}</td>
                <td>{{ item.sales }}</td>
              </tr>
            </tbody>
          </table>
        </TradePanel>
          </div>
        </div>

        <div class="right_r flex_wrap_pf flex_column">
          <div class="right_r_top flex_column">
        <TradePanel title="实时数据更新" class="realtime-panel">
          <div class="realtime-grid">
            <div v-for="item in realtimeData" :key="item.name" class="realtime-card">
              <img :src="panelIcon2" />
              <div>
                <span>{{ item.name }}</span>
                <strong>({{ item.value }})</strong>
              </div>
            </div>
          </div>
        </TradePanel>
          </div>

          <div class="right_r_mi flex_column">
            <TradePanel title="实时电商流水" class="flow-panel">
              <div class="flow-layout">
                <ChartBox :option="flowPieOption" />
                <div class="flow-legend">
                  <div v-for="item in flowData" :key="item.name" class="flow-row">
                    <span class="flow-dot" :style="{ background: item.color }"></span>
                    <span class="flow-name">{{ item.name }}</span>
                    <b :style="{ color: item.color }">{{ item.percent }}</b>
                  </div>
                </div>
              </div>
            </TradePanel>
          </div>

          <div class="right_r_down flex_column">
          <TradePanel title="用户购买转化率" class="rate-panel">
            <div class="unit-label percent">单位：%</div>
            <ChartBox :option="conversionRateOption" />
          </TradePanel>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">本产品由来村网提供技术支持</div>
  </div>
</template>

<script setup>
import * as echarts from "echarts";
import { computed } from "vue";
import nyTit from "@/components/nyTit1.vue";
import Tit from "@/components/Tit.vue";
import TradePanel from "@/components/xiaofeiTradeData/TradePanel.vue";
import MetricRing from "@/components/xiaofeiTradeData/MetricRing.vue";
import ChartBox from "@/components/xiaofeiTradeData/ChartBox.vue";
import SalesRankList from "@/components/xiaofeiTradeData/SalesRankList.vue";
import ProductMiniCards from "@/components/xiaofeiTradeData/ProductMiniCards.vue";

const panelIcon = "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/zy.png";
const panelIcon2 = "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/qg.png";

const overviewData = [
  { title: "2026年交易额", value: "12.68", unit: "亿元", trendValue: "+8.6%", trendDirection: "up" },
  { title: "2026年农产销售额", value: "9.75", unit: "亿元", trendValue: "+12.3%", trendDirection: "up" },
  { title: "2026年有效订单", value: "386.4", unit: "万单", trendValue: "+6.8%", trendDirection: "up" },
  { title: "经营主体", value: "1862", unit: "家", trendValue: "+3.5%", trendDirection: "up-red" },
];

const productData = [
  {name:"邵店黄姜",img:require("@/assets/img/ds_hj.png")},
  {name:"上蔡花生",img:require("@/assets/img/ds_hs.png")},
  {name:"朱里红薯",img:require("@/assets/img/ds_hs5.png")},
  {name:"羊肚菌",img:require("@/assets/img/ds_yd.png")},
];

const conversionData = [
  { label: "全平台访问UV:", value: "58.6万" },
  { label: "加购 / 收藏用户:", value: "12.8万" },
  { label: "提交订单用户:", value: "6.4万" },
  { label: "成交支付转化率:", value: "31.6%" },
];

const processingRank = [
  { name: "黄姜深加工", value: "31%", color: "#1ee3d7" },
  { name: "花生制品", value: "26%", color: "#f1d958" },
  { name: "红薯粉条", value: "18%", color: "#49b7ff" },
  { name: "羊肚菌干品", value: "14%", color: "#1fa2ff" },
  { name: "其他农副产品", value: "11%", color: "#4bd6ff" },
];

const miniGaugeData = [
  { name: "花生销量", value: "3.8", unit: "万吨" },
  { name: "黄姜销量", value: "2.6", unit: "万吨" },
  { name: "红薯销量", value: "2.1", unit: "万吨" },
  { name: "菌菇销量", value: "0.42", unit: "万吨" },
];

const realtimeData = [
  { name: "2026-07-08访问", value: "32.6万" },
  { name: "2026-07-08订单", value: "1.26万单" },
  { name: "2026-07农产销量", value: "8.9万件" },
  { name: "店铺异常预警", value: "18条" },
];

const flowData = [
  { name: "邵店黄姜", value: 3100, percent: "31%", color: "#19c9ff" },
  { name: "上蔡花生", value: 2600, percent: "26%", color: "#2d73ff" },
  { name: "朱里红薯", value: 1800, percent: "18%", color: "#d7b35f" },
  { name: "羊肚菌", value: 1400, percent: "14%", color: "#22d88c" },
  { name: "其他农副产品", value: 1100, percent: "11%", color: "#93c2ff" },
];

const topList = [
  { rank: "NO.01", town: "邵店镇", amount: "1.86亿", sales: "42.8万单" },
  { rank: "NO.02", town: "朱里镇", amount: "1.42亿", sales: "35.6万单" },
  { rank: "NO.03", town: "黄埠镇", amount: "1.18亿", sales: "28.9万单" },
  { rank: "NO.04", town: "蔡都街道", amount: "1.06亿", sales: "26.1万单" },
  { rank: "NO.05", town: "无量寺乡", amount: "0.92亿", sales: "22.4万单" },
  { rank: "NO.06", town: "杨集镇", amount: "0.78亿", sales: "19.7万单" },
  { rank: "NO.07", town: "五龙镇", amount: "0.66亿", sales: "16.8万单" },
  { rank: "NO.08", town: "和店镇", amount: "0.58亿", sales: "14.3万单" },
  { rank: "NO.09", town: "党店镇", amount: "0.49亿", sales: "12.1万单" },
  { rank: "NO.10", town: "东岸乡", amount: "0.42亿", sales: "10.6万单" },
];

function baseGrid(top = 50, bottom = 36, left = 58, right = 26) {
  return { top, bottom, left, right, containLabel: false };
}

const tradeTrendOption = computed(() => ({
  color: ["#168dff", "#23d9e7"],
  grid: baseGrid(150, 58, 72, 80),
  legend: {
    top: 30,
    right: 60,
    icon: "circle",
    itemWidth: 16,
    itemHeight: 16,
    textStyle: { color: "#cfe8ff", fontSize: 20 },
    data: ["月度交易额走势", "月度订单量走势"],
  },
  tooltip: { trigger: "axis" },
  xAxis: {
    type: "category",
    boundaryGap: false,
    data: ["2025.8", "2025.9", "2025.10", "2025.11", "2025.12", "2026.1", "2026.2", "2026.3", "2026.4", "2026.5", "2026.6", "2026.7"],
    axisTick: { show: false },
    axisLine: { lineStyle: { color: "rgba(106, 168, 230, .4)" } },
    axisLabel: { color: "#bcd9ff", fontSize: 17, margin: 18 },
  },
  yAxis: {
    type: "value",
    min: 0,
    max: 50,
    axisLabel: { color: "#d8e9ff", fontSize: 17 },
    splitLine: { lineStyle: { color: "rgba(159, 195, 235, .2)", type: "dashed" } },
  },
  series: [
    {
      name: "月度交易额走势",
      type: "line",
      smooth: true,
      symbolSize: 7,
      lineStyle: { width: 3 },
      areaStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: "rgba(22, 141, 255, .45)" },
          { offset: 1, color: "rgba(22, 141, 255, 0)" },
        ]),
      },
      data: [7.2, 8.6, 9.1, 9.7, 10.8, 8.9, 9.6, 10.4, 11.2, 12.1, 14.4, 14.8],
    },
    {
      name: "月度订单量走势",
      type: "line",
      smooth: true,
      symbolSize: 7,
      lineStyle: { width: 3 },
      areaStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: "rgba(35, 217, 231, .34)" },
          { offset: 1, color: "rgba(35, 217, 231, 0)" },
        ]),
      },
      data: [22.4, 25.7, 28.3, 30.1, 32.6, 27.8, 29.4, 31.5, 34.2, 37.1, 44.6, 42.7],
    },
  ],
}));

const onlineSalesOption = computed(() => ({
  color: ["#158dff"],
  grid: baseGrid(100, 60, 55, 60),
  tooltip: {
    trigger: "axis",
    textStyle: { fontSize: 30 },
  },
  xAxis: {
    type: "category",
    boundaryGap: false,
    data: ["7.1", "7.2", "7.3", "7.4", "7.5", "7.6", "7.7", "7.8"],
    axisTick: { show: false },
    axisLine: { show: false },
    axisLabel: { color: "#9fc8f3", fontSize: 15 },
  },
  yAxis: {
    type: "value",
    axisLabel: { color: "#9fc8f3", fontSize: 15 },
    splitLine: { lineStyle: { color: "rgba(122, 175, 225, .13)" } },
  },
  series: [
    {
      type: "line",
      smooth: true,
      symbolSize: 10,
      lineStyle: { width: 4 },
      areaStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: "rgba(24, 132, 255, .55)" },
          { offset: 1, color: "rgba(24, 132, 255, .05)" },
        ]),
      },
      markPoint: {
        symbol: "circle",
        symbolSize: 10,
        label: { formatter: "2026.7.5\n1250万元", color: "#fff", fontSize: 26, backgroundColor: "rgba(40, 62, 86, .8)", padding: 18 },
        data: [{ coord: ["7.5", 1250] }],
      },
      data: [680, 760, 910, 1040, 1250, 1120, 980, 1086],
    },
  ],
}));

const sourceBarOption = computed(() => ({
  color: ["#0bbdff"],
  grid: baseGrid(50, 50, 90, 30),
  tooltip: { trigger: "axis" },
  xAxis: {
    type: "category",
    data: ["直播电商", "短视频平台", "搜索商城", "线下门店引流", "外部推广", "社群裂变"],
    axisTick: { show: false },
    axisLine: { lineStyle: { color: "rgba(83, 147, 214, .3)" } },
    axisLabel: { color: "#9fc8f3", fontSize: 14, interval: 0,  },
  },
  yAxis: {
    type: "value",
    max: 350,
    axisLabel: { color: "#9fc8f3", fontSize: 14 },
    splitLine: { lineStyle: { color: "#2C4D6F", type: "dashed" } },
  },
  series: [
    {
      type: "bar",
      barWidth: 24 ,
      borderRadius: 20,
      itemStyle: {
        borderRadius: [12, 12, 0, 0],
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: "#18d6ff" },
          { offset: 1, color: "#0b46b7" },
        ]),
      },
      showBackground: true,
      backgroundStyle: { color: "rgba(21, 84, 168, .58)" ,borderRadius: [12, 12, 0, 0]}, 
      data: [286, 214, 176, 98, 76, 142],
      markPoint: {
        symbol: "pin",
        symbolSize: 58,
        itemStyle: { color: "rgba(22, 143, 255, .8)"},
        label: { color: "#dff5ff", formatter: "286" , fontSize: 16 },
        data: [{ coord: ["直播电商", 286] }],
      },
    },
  ],
}));

const processingDonutOption = computed(() => ({
  series: [
    {
      type: "pie",
      radius: ["46%", "72%"],
      center: ["40%", "52%"],
      label: { show: false },
      itemStyle: { borderWidth: 10, borderColor: "#01152D" },
      data: processingRank.map((item) => ({ value: parseInt(item.value), name: item.name, itemStyle: { color: item.color } })),
    },
  ],
  graphic: [
    { type: "text", left: "32%", top: "49%", style: { text: "100%", fill: "#1bd6ff", fontSize: 28, fontWeight: "bold" } },
  ],
}));

const trendCompareOption = computed(() => ({
  color: ["#1b7dff", "#d4b85a"],
  grid: baseGrid(100, 42, 55, 30),
  legend: {
    top: 26,
    right: 70,
    icon: "rect",
    itemWidth: 18,
    itemHeight: 5,
    textStyle: { color: "#cfe8ff", fontSize: 13 },
    data: ["24 小时订单转化率", "24 小时新增成交率"],
  },
  tooltip: { trigger: "axis" },
  xAxis: {
    type: "category",
    boundaryGap: false,
    data: ["7/7 14时", "7/7 17时", "7/7 20时", "7/7 23时", "7/8 02时", "7/8 05时", "7/8 08时", "7/8 11时", "7/8 14时"],
    axisTick: { show: false },
    axisLine: { lineStyle: { color: "rgba(106, 168, 230, .6)" } },
    axisLabel: { color: "#bcd9ff", fontSize: 14, margin: 18 },
  },
  yAxis: {
    type: "value",
    min: 0,
    max: 1,
    axisLabel: { color: "#d8e9ff", fontSize: 14 },
    splitLine: { lineStyle: { color: "rgba(159, 195, 235, .5)", type: "dashed" } },
  },
  series: [
    { name: "24 小时订单转化率", type: "line", smooth: true, symbol: "none", areaStyle: {  color: new echarts.graphic.LinearGradient(
        // 渐变方向：x0,y0 → x1,y1（取值0-1，代表容器比例）
        0, 0,  // 起点：左上角
        0, 1,  // 终点：左下角 = 垂直从上到下渐变
        [
          { offset: 0, color: 'rgba(212, 184, 90, .22)' }, // 顶部（折线位置）颜色
          { offset: 1, color: 'rgba(54, 163, 247, 0)' }  // 底部（X轴位置）接近透明
        ]
      ) }, data: [0.31, 0.34, 0.29, 0.27, 0.24, 0.26, 0.38, 0.42, 0.39] },
    { name: "24 小时新增成交率", type: "line", smooth: true, symbol: "none", areaStyle: { color: new echarts.graphic.LinearGradient(
        // 渐变方向：x0,y0 → x1,y1（取值0-1，代表容器比例）
        0, 0,  // 起点：左上角
        0, 1,  // 终点：左下角 = 垂直从上到下渐变
        [
          { offset: 0, color: 'rgba(212, 184, 90, .22)' }, // 顶部（折线位置）颜色
          { offset: 1, color: 'rgba(54, 163, 247, 0)' }  // 底部（X轴位置）接近透明
        ]
      ) }, data: [0.18, 0.20, 0.17, 0.15, 0.14, 0.16, 0.23, 0.28, 0.25] },
  ],
}));

const flowPieOption = computed(() => ({
  series: [
    {
      type: "pie",
      radius: ["48%", "74%"],
      center: ["48%", "52%"],
      label: { show: false },
      data: flowData.map((item) => ({ value: item.value, name: item.name, itemStyle: { color: item.color } })),
    },
  ],
  graphic: [{ type: "text", left: "39%", top: "49%", style: { text: "100%", fill: "#1bd6ff", fontSize: 24, fontWeight: "bold" } }],
}));

const conversionRateOption = computed(() => ({
  color: ["#d1b45e"],
  grid: baseGrid(90, 42, 58, 60),
  tooltip: { trigger: "axis" },
  xAxis: {
    type: "category",
    boundaryGap: false,
    data: ["2026.1", "2026.2", "2026.3", "2026.4", "2026.5", "2026.6", "2026.7"],
    axisTick: { show: false },
    axisLine: { lineStyle: { color: "rgba(106, 168, 230, .35)" } },
    axisLabel: { color: "#bcd9ff", fontSize: 14, margin: 18 },
  },
  yAxis: {
    type: "value",
    min: 0,
    max: 1,
    axisLabel: { color: "#d8e9ff", fontSize: 14 },
    splitLine: { lineStyle: { color: "rgba(159, 195, 235, .16)", type: "dashed" } },
  },
  series: [
    {
      type: "line",
      smooth: true,
      symbolSize: 7,
      lineStyle: { width: 3 },
      areaStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: "rgba(209, 180, 94, .32)" },
          { offset: 1, color: "rgba(209, 180, 94, 0)" },
        ]),
      },
      data: [0.24, 0.27, 0.29, 0.31, 0.34, 0.36, 0.316],
    },
  ],
}));
</script>

<style lang="less" scoped>
.trade-page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: #dcefff;
  background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data1/bj.jpg") no-repeat top center;
  background-size: 100% 100%;
  position: relative;
}

.top-frame {
  position: absolute;
  top: 0;
  left: 1980px;
  width: 1820px;
  height: 64px;
  border-top: 4px solid #1fd4ff;
  border-left: 2px solid rgba(31, 212, 255, .65);
  border-right: 2px solid rgba(31, 212, 255, .65);
  clip-path: polygon(4% 0, 96% 0, 100% 24%, 96% 56%, 54% 56%, 52% 92%, 48% 92%, 46% 56%, 4% 56%, 0 24%);
  opacity: .8;
}

.trade-content {
  position: absolute;
  left: 45px;
  right: 45px;
  top: 220px;
  bottom: 54px;
  display: grid;
  grid-template-columns: 1780px 880px 880px 880px 865px;
  gap: 42px;
}

.col {
  min-width: 0;
  min-height: 0;
}

.col-left {
  display: grid;
  grid-template-rows: 500px 1fr;
  gap: 22px;
}

.page-heading {
  height: 44px;
  line-height: 44px;
  color: #e5f6ff;
  font-size: 24px;
  font-weight: bold;
  position: relative;
  padding-left: 38px;
}

.page-heading:before {
  content: ">>";
  position: absolute;
  left: 0;
  color: #48caff;
}

.page-heading:after {
  content: "";
  position: absolute;
  left: 278px;
  bottom: 5px;
  width: 540px;
  height: 6px;
  background: linear-gradient(90deg, #f6d93b 0 25%, #0ed5ff 25% 100%);
  clip-path: polygon(0 0, 100% 0, 96% 100%, 0 100%);
}

.overview-grid {
  height: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 34px;
  padding: 34px 34px 28px;
  box-sizing: border-box;
}

.left-lower {
  min-height: 0;
  display: grid;
  grid-template-columns: 1.08fr .92fr;
  gap: 48px;
}

.unit-label {
  position: absolute;
  left: 28px;
  top: 58px;
  z-index: 2;
  color: #e6f4ff;
  font-size: 21px;
}

.unit-label.percent {
  left: 30px;
  top: 30px;
}

.product-grid {
  height: 100%;
  padding: 36px 28px 28px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 34px 36px;
}

.product-card {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #18caff;
  font-size: 24px;
  font-weight: bold;
  border: 2px solid rgba(89, 147, 212, .65);
  // background: rgba(8, 44, 91, .28);
  box-shadow: inset 0 0 28px rgba(37, 123, 205, .16);
  padding: 6px;
  img {
    width: 100%;
    height: 100%;
  }
}

.col-conversion {
  display: grid;
  grid-template-rows: 480px 1fr;
  gap: 24px;
  padding-top: 54px;
  box-sizing: border-box;
}

.conversion-list {
  height: 100%;
  padding: 18px 36px 24px;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: repeat(4, 1fr);
  gap: 20px;
}

.conversion-row {
  background: linear-gradient(
    to right,
    rgba(4, 53, 99, 0.5),
    rgba(4, 53, 99, 0.1)
  );
  display: flex;
  align-items: center;
  min-height: 0;
}

.conversion-row img {
  width: 70px;
  height: 70px;
  margin-left: 30px;
}

.conversion-row span {
  display: block;
  width: 330px;
  color: #fff;
  font-size: 26px;
  margin-left: 34px;
  text-align: left;
  font-weight: bold;
}

.conversion-row .conversion-value {
  width: 260px;
  color: #ffd15c;
  font-size: 40px;
  margin-left: 30px;
  font-weight: normal;
}

.sub-title,
.donut-title {
  position: absolute;
  left: 34px;
  top: 28px;
  color: #16c7ff;
  font-size: 28px;
  font-weight: bold;
  z-index: 2;
}

.col-source {
  display: grid;
  grid-template-rows: 480px 62px 295px 142px;
  gap: 14px;
  padding-top: 54px;
  box-sizing: border-box;
}

.donut-title {
  position: static;
  height: 62px;
  line-height: 62px;
  text-align: center;
}

.donut-row {
  display: grid;
  grid-template-columns: 330px 1fr;
  min-height: 0;
}

.col-trend {
  display: grid;
  grid-template-rows: 520px 1fr;
  gap: 24px;
  padding-top: 54px;
  box-sizing: border-box;
}

.top-table {
  width: calc(100% - 24px);
  margin: 24px 12px 0;
  border-collapse: collapse;
  color: #a9d3fb;
  font-size: 22px;
}

.top-table th {
  height: 50px;
  background: rgba(21,77,160,0.2);
  color: #bfe9ff;
  font-weight: normal;
}

.top-table td {
  height: 50px;
  text-align: center;
}

.top-table tr.active {
  color: #e8f7ff;
  background: linear-gradient( 270deg, rgba(26,123,230,0) 0%, rgba(69,193,255,0.8) 100%);
}

.col-realtime {
  display: grid;
  grid-template-rows: 330px 380px 1fr;
  gap: 24px;
  padding-top: 54px;
  box-sizing: border-box;
}

.realtime-grid {
  height: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  padding: 34px 34px 20px;
  box-sizing: border-box;
  gap: 28px 48px;
}

.realtime-card {
  display: flex;
  align-items: center;
  color: #dbefff;
}

.realtime-card img {
  width: 48px;
  height: 48px;
  margin-right: 14px;
}

.realtime-card span,
.realtime-card strong {
  display: block;
  font-size: 30px;
  line-height: 34px;
  text-align: center;
  font-family: '微软雅黑';
}

.realtime-card strong {
  color: #f0d151;
  font-weight: normal;
  margin-top: 12px;
}

.flow-layout {
  height: 100%;
  display: grid;
  grid-template-columns: 360px 1fr;
}

.flow-legend {
  padding: 42px 22px 0 0;
}

.flow-row {
  height: 57px;
  margin-bottom: 16px;
  display: grid;
  grid-template-columns: 16px 1fr 58px;
  gap: 20px;
  align-items: center;
  background: linear-gradient( 90deg, rgba(0,105,255,.2) 0%, rgba(45,105,187,0) 100%);
  color: #9fd0fb;
  font-size: 24px;
  padding: 0 12px;
  box-sizing: border-box;
}
.flow-name{
  text-align: left;
}

.flow-dot {
  width: 21px;
  height: 21px;
}

.flow-row b {
  color: #21d5ff;
  font-weight: normal;
  text-align: right;
}

.footer {
  width: 100%;
  height: 30px;
  line-height: 30px;
  color: #fff;
  text-align: center;
  font-size: 30px;
  position: fixed;
  bottom: 22px;
  left: 0;
  z-index: 10000;
  font-weight: bold;
}

.mainBox {
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: #dcefff;
  background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data1/bj.jpg")
    no-repeat top center;
  background-size: 100% 100%;
  position: relative;

  .content {
    top: 220px;
    left: 0;
    width: 100%;
    position: absolute;
    height: calc(100% - 310px);
    flex-flow: row;
    display: flex;
  }

  .flex_column {
    display: flex;
    flex-direction: column;
  }

  .ggtxt {
    width: 100%;
    flex: 1;
  }

  .flex_wrap {
    display: flex;
  }

  .flex_wrap_pf {
    flex: 1;
    height: 100%;
    min-width: 0;
    min-height: 0;
  }

  .left {
    width: 2000px;
    height: 100%;
    margin-left: 100px;
    display: flex;
    gap: 50px;
  }

  .left_top {
    width: 100%;
    height: 500px;
    min-height: 0;
  }

  .left_down {
    width: 100%;
    flex: 1;
    min-height: 0;
    gap: 48px;
    padding-top: 22px;
    box-sizing: border-box;
  }

  .left_down_left,
  .left_down_right {
    min-width: 0;
    min-height: 0;
  }

  .middle {
    flex: 1;
    height: 100%;
    margin: 0 50px;
    padding-top: 50px;
    box-sizing: border-box;
    gap: 28px;
    min-width: 0;
  }

  .middle_left,
  .middle_right {
    gap: 24px;
    min-width: 0;
    min-height: 0;
  }

  .right {
    width: 2000px;
    height: 100%;
    margin-right: 100px;
    gap: 28px;
  }

  .right_l,
  .right_r {
    gap: 24px;
    min-width: 0;
    min-height: 0;
  }

  .right_l_top {
    width: 100%;
    height: 580px;
    min-height: 0;
    margin-bottom: 30px;
  }

  .right_l_down {
    flex: 1;
    min-height: 0;
  }

  .right_r_top {
    width: 100%;
    height: 330px;
    min-height: 0;
  }

  .right_r_mi {
    width: 100%;
    height: 480px;
    min-height: 0;
  }

  .right_r_down {
    flex: 1;
    min-height: 0;
  }
}

.overview-panel,
.conversion-panel,
.sales-panel,
.source-panel,
.compare-panel,
.top-table-panel,
.realtime-panel,
.flow-panel,
.rate-panel {
  min-height: 0;
}

.conversion-panel,
.source-panel {
  height: 650px;
}
.height_500{
  height: 500px;
}

.sales-panel {
  flex: 1;
}

.donut-title {
  height: 62px;
  line-height: 62px;
}

.donut-row {
  height: 400px;
}

.mini-gauge-row {
  flex: 1;
}

.mainBox .middle :deep(.title) {
  background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/cbt.png")
    no-repeat;
}

.mainBox .middle .sales-panel :deep(.title),
.mainBox .middle .source-panel :deep(.title) {
  background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/dbt.png")
    no-repeat;
}



.footer {
  bottom: 30px;
}
</style>
